import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare, faSquareCheck } from '@fortawesome/free-regular-svg-icons';
export const QuizForm = ({ quiz: quizData, onSubmit, onCancel, }) => {
    const [validationMessage, setValidationMessage] = useState('');
    const [quiz, setQuiz] = useState(quizData || {
        name: '',
        duration: '600',
        settings: {
            shuffleQuestions: false,
            sendResultEmail: false,
            public: false,
            timed: false,
        },
    });
    const handleNameChange = (e) => {
        if (e.target.value.length <= 35) {
            setQuiz({
                ...quiz,
                name: e.target.value,
            });
        }
        else {
            e.target.value = e.target.value.slice(0, 35);
        }
    };
    const handleDurationChange = (e) => {
        setQuiz({
            ...quiz,
            duration: e.target.value,
        });
    };
    const handleTimedSettingChange = () => {
        setQuiz({
            ...quiz,
            duration: '600',
            settings: {
                ...quiz.settings,
                timed: !quiz.settings.timed,
            },
        });
    };
    const handleShuffleQuestionsSettingChange = () => {
        setQuiz({
            ...quiz,
            settings: {
                ...quiz.settings,
                shuffleQuestions: !quiz.settings.shuffleQuestions,
            },
        });
    };
    const handlePublicSettingChange = () => {
        setQuiz({
            ...quiz,
            settings: {
                ...quiz.settings,
                public: !quiz.settings.public,
            },
        });
    };
    const handleSendResultEmailSettingChange = () => {
        setQuiz({
            ...quiz,
            settings: {
                ...quiz.settings,
                sendResultEmail: !quiz.settings.sendResultEmail,
            },
        });
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (quiz.name === '') {
            setValidationMessage('Quiz Name cannot be empty');
        }
        else {
            onSubmit(quiz);
        }
    };
    return (React.createElement("form", { className: "form", onSubmit: handleSubmit },
        React.createElement("div", { className: "form__control" },
            React.createElement("div", { className: "input-group" },
                React.createElement("input", { type: "text", name: "quizName", placeholder: " ", defaultValue: quiz.name, onChange: handleNameChange, onFocus: () => {
                        setValidationMessage('');
                    } }),
                React.createElement("label", null, "Quiz Name"),
                React.createElement("span", { className: "character-count" },
                    quiz.name.length,
                    " / 35")),
            React.createElement("div", { className: "options-group" },
                React.createElement("div", null,
                    React.createElement(FontAwesomeIcon, { id: "A", icon: quiz.settings.timed === true ? faSquareCheck : faSquare, className: "faCheckBox", onClick: handleTimedSettingChange }),
                    React.createElement("label", null, "Timed")),
                React.createElement(FontAwesomeIcon, { id: "A", icon: quiz.settings.shuffleQuestions === true ? faSquareCheck : faSquare, className: "faCheckBox", onClick: handleShuffleQuestionsSettingChange }),
                React.createElement("label", null, "Shuffle Questions"),
                React.createElement(FontAwesomeIcon, { id: "A", icon: quiz.settings.sendResultEmail === true ? faSquareCheck : faSquare, className: "faCheckBox", onClick: handleSendResultEmailSettingChange }),
                React.createElement("label", null, "Send Result Email"),
                React.createElement(FontAwesomeIcon, { id: "A", icon: quiz.settings.public === true ? faSquareCheck : faSquare, className: "faCheckBox", onClick: handlePublicSettingChange }),
                React.createElement("label", null, "Share Publicly")),
            quiz.settings.timed && (React.createElement("div", { className: "range-group" },
                React.createElement("span", { className: "duration-label" },
                    "Duration:",
                    ' ',
                    quiz.duration
                        ? parseInt(quiz.duration) < 600
                            ? `0${parseInt(quiz.duration) / 60}`
                            : parseInt(quiz.duration) / 60
                        : undefined,
                    ' ',
                    "min"),
                React.createElement("input", { type: "range", min: '300', max: '3600', step: 300, defaultValue: quiz.duration, onChange: handleDurationChange })))),
        React.createElement("div", { className: "form-actions" },
            React.createElement("button", { className: "btn--primary", type: "submit" }, quizData ? 'Update' : 'Create'),
            React.createElement("button", { type: "button", className: "btn--secondary", onClick: onCancel }, "Cancel")),
        React.createElement("p", { className: "validation-message" }, validationMessage)));
};
